/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { HistoryDto } from '../../models/history-dto';

export interface GetHistoricalInformationById$Params {
  historyId: number;
}

export function getHistoricalInformationById(
  http: HttpClient,
  rootUrl: string,
  params: GetHistoricalInformationById$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<HistoryDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    getHistoricalInformationById.PATH,
    'get',
  );
  if (params) {
    rb.path('historyId', params.historyId, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<HistoryDto>;
      }),
    );
}

getHistoricalInformationById.PATH = '/history/{historyId}';
